import React from 'react';
import { Button, ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setShowRequestedBenefitModal } from '../../redux/modules/show';
import { formatMoney } from '../../utils/formatMoney';
import './styles/requestedBenefitCard.scss';

function mapDispatchToProps(dispatch) {
  return {
    setShowRequestedBenefitModal: (show) =>
      dispatch(setShowRequestedBenefitModal(show)),
  };
}

function ConnectedRequestedBenefitCardComponent(props) {
  const { benefit } = props;

  const handleClick = () => {
    props.onClick();
  };

  //console.log(benefit);

  return (
    <div
      className='requested-benefit-card-component'
      style={{ height: benefit.thumbnail ? '415px' : '270px' }}>
      {benefit.thumbnail && (
        <div className='benefit-thumbnail-container'>
          <div
            className='benefit-thumbnail'
            style={{ backgroundImage: `url(${benefit.thumbnail})` }}
          />
        </div>
      )}
      <div style={{ padding: '5px 20px' }}>
        <div className='benefit-name'>{benefit.name}</div>
        <div className='benefit-desc'>{benefit.description}</div>
        <div className='benefit-user-name'>
          {!benefit.anonymousRequest && (
            <>
              Solicitada por: {benefit.userFirstName}{' '}
              {benefit.userLastName}
            </>
          )}
        </div>
        {benefit.moneyRaise && (
          <div className='benefit-progress-bar'>
            <div className='progress-label'>
              {benefit.amountRaised &&
              parseInt(benefit.amountRaised) >= benefit.goal
                ? '¡Meta alcanzada!'
                : `${
                    !benefit.amountRaised
                      ? 0
                      : formatMoney(Math.floor(benefit.amountRaised))
                  } de ${formatMoney(benefit.goal)}`}
            </div>
            <ProgressBar
              now={
                !benefit.amountRaised
                  ? 0
                  : (benefit.amountRaised / benefit.goal) * 100
              }
            />
          </div>
        )}
        <Button
          onClick={handleClick}
          className='app-button benefit-button'>
          Ver más
        </Button>
      </div>
    </div>
  );
}

const RequestedBenefitCardComponent = connect(
  null,
  mapDispatchToProps
)(ConnectedRequestedBenefitCardComponent);

export default withRouter(RequestedBenefitCardComponent);
